import React, { createContext, useContext, useCallback, useState } from 'react';

interface GlobalRestartContextValue {
  onRestart: () => void;
  setRestartCallback: (callback: () => void) => void;
}

const GlobalRestartContext = createContext<GlobalRestartContextValue | null>(null);

export function GlobalRestartProvider({ children }: { children: React.ReactNode }) {
  const [restartCallback, setRestartCallbackState] = useState<(() => void) | null>(null);

  const setRestartCallback = useCallback((callback: () => void) => {
    setRestartCallbackState(() => callback);
  }, []);

  const onRestart = useCallback(() => {
    if (restartCallback) {
      restartCallback();
    }
  }, [restartCallback]);

  return (
    <GlobalRestartContext.Provider value={{ onRestart, setRestartCallback }}>
      {children}
    </GlobalRestartContext.Provider>
  );
}

export function useGlobalRestart() {
  const context = useContext(GlobalRestartContext);
  if (!context) {
    throw new Error('useGlobalRestart must be used within GlobalRestartProvider');
  }
  return context;
}
